import type {Schemas} from 'domainTypes/dto';
import {mapWorkToSeriesRelationDto} from 'services/agent/mappers/mapRelationsDto';
import type {Collection} from '../types';
import {sortCollectionLinks} from '../functions';
import {
  mapCollectionTypeDto,
  mapToCollectionTypeDto,
} from './mapCollectionTypeDto';

export const mapGetCollectionDto = (
  dto: Schemas.SeriesWithRelationsDto,
): Collection => {
  let links = (dto.relations ?? []).map(relationDto =>
    mapWorkToSeriesRelationDto(relationDto),
  );
  links = sortCollectionLinks(links);
  return {
    id: dto.id,
    collectionType: mapCollectionTypeDto(dto.seriesType),
    titles: dto.titles,
    note: dto.note,
    links,
  };
};

export const mapToUpsertCollectionDto = (
  collectionWithoutId: Omit<Collection, 'id'>,
): Schemas.CreateOrUpdateSeriesDto => {
  return {
    titles: collectionWithoutId.titles,
    seriesType: mapToCollectionTypeDto(collectionWithoutId.collectionType),
    note: collectionWithoutId.note,
  };
};
